import { LearningObject, Course } from '../';
import type { ILearningObjectData } from '../';
import type { ILearningProgram } from '.';

export class LearningProgram extends LearningObject implements ILearningProgram {
  courses: Course[] = [];

  constructor(data: ILearningObjectData) {
    super(data);

    if (data?.courses) {
      this.courses = data.courses.map((c) => new Course({ ...c, parentId: this.id }));
      if (!this.isFlexible) {
        this.courses = this.courses.map((c) => {
          if (!c.activeInstance) {
            c.instance = c.defaultInstance;

            if (this.activeInstance?.subInstances) {
              const subInstance = this.activeInstance?.subInstances.find((item) => item.learningObjectId == c.id);
              if (subInstance) c.instance = subInstance;
            }
          }
          return c;
        });
      }
    }
  }

  get activeCourseId(): string | undefined {
    return this.courses.find((c) => !c.hasPassed)?.id || this.courses[0]?.id;
  }

  get inactiveCourses(): Course[] {
    return this.courses.filter((course) => !course.activeInstance);
  }

  get isEnrollable(): boolean {
    if (!this.enrollment && this.activeInstances && !this.isDeadlinePassed && !this.inactiveCourses.length) return true;
    return false;
  }

  get isActive(): boolean {
    if (this.enrollment && !!this.activeInstance && !this.isDeadlinePassed && !this.inactiveCourses.length) return true;
    return false;
  }

  validate(): void {
    throw new Error('Method not implemented.');
  }
}
